import { SvgIcon } from '@mui/material';
import React from 'react';


function RuleIcon(props: any) {
    return(
        <SvgIcon
            width="54" height="64" viewBox="0 0 54 64" 
            fill="none" xmlns="http://www.w3.org/2000/svg"
            {...props}
        >  
            <path d="M52.2292 11.3083C47.8859 10.1492 43.6428 8.64292 39.5408 6.80417C35.5052 5.05351 31.6094 2.99668 27.8875 0.651667L26.8333 0L25.7983 0.670833C22.0765 3.01584 18.1807 5.07268 14.145 6.82333C10.0362 8.65651 5.7867 10.1563 1.4375 11.3083L0 11.6725V27.6575C0 53.3217 25.9325 62.9242 26.1817 63.02L26.8333 63.25L27.485 63.02C27.7533 63.02 53.6667 53.3408 53.6667 27.6575V11.6725L52.2292 11.3083ZM43.47 24.0542L22.0608 44.85L9.9475 32.7175C9.43917 32.2092 9.15359 31.5197 9.15359 30.8008C9.15359 30.0819 9.43917 29.3925 9.9475 28.8842C10.4558 28.3758 11.1453 28.0903 11.8642 28.0903C12.5831 28.0903 13.2725 28.3758 13.7808 28.8842L22.1183 37.375L39.7325 20.125C39.9842 19.8733 40.283 19.6736 40.6119 19.5374C40.9407 19.4012 41.2932 19.3311 41.6492 19.3311C42.0051 19.3311 42.3576 19.4012 42.6865 19.5374C43.0153 19.6736 43.3141 19.8733 43.5658 20.125C43.8175 20.3767 44.0172 20.6755 44.1534 21.0044C44.2896 21.3332 44.3597 21.6857 44.3597 22.0417C44.3597 22.3976 44.2896 22.7501 44.1534 23.079C44.0172 23.4078 43.8175 23.7066 43.5658 23.9583L43.47 24.0542Z" fill="white"/>
        </SvgIcon>
    )
}

export default RuleIcon;
